import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Box } from "@material-ui/core";
import useTabPanelStyles from "../../styles/TabPanel.style";
import useStyles from "./RaffleDrawTabPanel.style";
import { RaffleDrawsList } from "./components/RaffleDrawsList";
import { GeneralSettings } from "./components/GeneralSettings";
import { RaffleDrawParticipants } from "./components/RaffleDrawParticipants";
import { Tabs } from "antd";
import useTabStyles from "../../styles/Tab.style";
import RaffleDrawParticipant from "../../../../models/RaffleDrawParticipant";
import ICIPAdminService from "../../../../services/ICIPAdminService";
import RaffleDrawsWinnersList from "./components/RaffleDrawsWinnersList";
import GeneralSettingService from "../../../../services/GeneralSettingService";
import { WinningPackagesList } from "./components/WinningPackagesList";
import SpecialRaffleDrawInProgress from "./components/SpecialRaffleDrawInProgress";
import ImportExcelFile from "./components/ImportExcelFile";
import {RaffleDrawResume} from "./components/raffle-resume/RaffleDrawResume";

interface RaffleDrawTabPanelProps {
  closeCallback: (succeed: boolean) => void;
}

export const RaffleDrawTabPanel = (props: RaffleDrawTabPanelProps) => {
  const { closeCallback } = props;
  const classes = useStyles(props);
  const tabPanelClasses = useTabPanelStyles(props);
  const [error, setError] = useState(false);
  const [succeed, setSucceed] = useState(false);
  const [settings, setSettings] = useState({});
  const intl = useIntl();
  const { formatMessage } = useIntl();

  const { TabPane } = Tabs;
  const tabClasses = useTabStyles(props);

  const fetchGeneralSettings = () => {
    GeneralSettingService.getGeneralSettings().then((response) => {
      if (response.isSuccess) {
        switch (response.data.code) {
          case 100:
            const settings = JSON.parse(JSON.stringify(response.data.data));
            setSettings(settings);
            break;
          case 110:
            setError(true);
            console.log(error);
            break;
        }
      } else {
        setError(true);
      }
      //setLoading(false);
    });
  };

  // State

  const [raffleDraws, setRaffleDraws] = useState([]);
  const [raffleDrawsEntries, setRaffleDrawsEntries] = useState([]);
  const [raffleDrawParticipant, setRaffleDrawParticipant] = useState(
    (): Array<RaffleDrawParticipant> => []
  );
  const [selectedRaffleDraw, setSelectedRaffleDraw] = useState(null);
  const [selectedRaffleDrawId, setSelectedRaffleDrawId] = useState(0);
  const [showEntries, setShowEntries] = useState(true);
  const [inputFields, setInputFields] = useState(0);
  const [winnersTable, setWinnersTable] = useState([]);

  const getAllRaffleDraw = () => {
    ICIPAdminService.getRaffleDraws().then((response) => {
      if (response.isSuccess && response.data.code === 100) {
        const resultRaffleDraws = JSON.parse(
          JSON.stringify(response.data.data)
        );
        setRaffleDraws(resultRaffleDraws);
        resultRaffleDraws.forEach((item, index) => {
          setSelectedRaffleDrawId(item.id);
        });
        setSelectedRaffleDrawId(resultRaffleDraws.id);
      }
    });
  };

  useEffect(() => {
    fetchGeneralSettings();
    getAllRaffleDraw();
  }, []);

  return (
    <Box component="div" className={tabPanelClasses.root}>
      <Box component="div" className={classes.tabsPanel}>
        <Tabs defaultActiveKey="1" centered>
          <TabPane
              tab={intl.formatMessage({ id: "sharedScreen.statAndOthers" })}
              key="8"
          >
            <RaffleDrawResume />
          </TabPane>
          <TabPane
            tab={intl.formatMessage({ id: "sharedScreen.generalSettings" })}
            key="4"
          >
            <Box component="div" className={classes.wrapper}>
              <Box component="div" className={classes.settingsWrapper}>
                <GeneralSettings settings={settings} />
              </Box>
            </Box>
          </TabPane>

          <TabPane
            tab={intl.formatMessage({
              id: "sharedScreen.winningPackages",
            })}
            key="2"
          >
            <WinningPackagesList />
          </TabPane>

          <TabPane
            tab={intl.formatMessage({ id: "sharedScreen.raffleDrawList" })}
            key="1"
          >
            <Box component="div" className={classes.wrapper}>
              <Box component="div" className={classes.settingsWrapper}>
                <Box component="span" className="mainTitle">
                  <FormattedMessage id="sharedScreen.raffleDrawList" />
                </Box>
                <RaffleDrawsList />
              </Box>
            </Box>
          </TabPane>

          <TabPane
            tab={intl.formatMessage({
              id: "sharedScreen.raffleDrawWParticipantList",
            })}
            key="3"
          >
            <Box component="div" className={classes.wrapper}>
              <Box component="div" className={classes.settingsWrapper}>
                <RaffleDrawParticipants />
              </Box>
            </Box>
          </TabPane>

          <TabPane
            tab={intl.formatMessage({
              id: "sharedScreen.raffleDrawEntriesWinners",
            })}
            key="5"
          >
            <RaffleDrawsWinnersList />
          </TabPane>
          <TabPane
            tab={intl.formatMessage({
              id: "sharedScreen.specialRaffleDraw",
            })}
            key="6"
          >
            <SpecialRaffleDrawInProgress />
          </TabPane>
          <TabPane
            tab={intl.formatMessage({
              id: "sharedScreen.importExcel",
            })}
            key="7"
          >
            <ImportExcelFile />
          </TabPane>
        </Tabs>
      </Box>
    </Box>
  );
};
